import type { Action } from 'svelte/action';
import { focusSibling } from '$lib/utils/focus';

// Mirrors focus-trap's isKeyForward/isKeyBackward: a document-level capture listener so ArrowDown/Up
// enter the trap even while the trigger still has focus, and only the innermost open trap handles them.
const stack: HTMLElement[] = [];

const onKeydown = (event: KeyboardEvent): void => {
	const node = stack[stack.length - 1];
	if (!node || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
	event.preventDefault();
	focusSibling(node, event.key === 'ArrowDown' ? 'next' : 'prev');
};

const push = (node: HTMLElement): void => {
	if (stack.includes(node)) return;
	if (stack.length === 0) document.addEventListener('keydown', onKeydown, true);
	stack.push(node);
};

const remove = (node: HTMLElement): void => {
	const index = stack.indexOf(node);
	if (index === -1) return;
	stack.splice(index, 1);
	if (stack.length === 0) document.removeEventListener('keydown', onKeydown, true);
};

export const arrowKeyNavigation: Action<HTMLElement, boolean | undefined> = (
	node,
	enabled = true
) => {
	if (enabled) push(node);
	return {
		update(next = true) {
			if (next) push(node);
			else remove(node);
		},
		destroy() {
			remove(node);
		}
	};
};
